import React, {Component} from 'react';


class LoadingContainerReview extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            text : ''
        }
    }
    componentDidMount() {
        let texts = ["Loading DBQs, please wait","Loading DBQs, please wait","Loading DBQs, please wait .", "Loading DBQs, please wait ..", "Loading DBQs, please wait ..."];
        let index = 0;
        this.setState({text : texts[index]})
                this.interval = setInterval(() => {
                    this.setState({ text: texts[++index] })
                    if (index === texts.length-1) {
                        index = 0
                    }
                }, 500);
      }
      componentWillUnmount() {
        clearInterval(this.interval);
      }
    render() {
        return (
           
            <h4>{this.state.text}</h4>
            
        );
    }
}

export default LoadingContainerReview